/* eslint camelcase: 0 */
import { FormControl, Select } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 40
const ITEM_PADDING_TOP = 0

export const AuditLogFormControl = styled(FormControl)<{ isselected?: string; is_opened: string; is_disabled: string }>`
  border-radius: ${theme.attributes.borderRadius.small};
  min-width: 113px;
  background: transparent;
  border: 1px solid ${theme.colors.controlBorder};
  height: 40px;
  z-index: 10;

  &:hover {
    border: 1px solid ${theme.colors.cta};
    background: rgba(208, 188, 255, 0.16);
  }

  justify-content: center;

  .MuiOutlinedInput-root {
    background: transparent;
    border-color: transparent;
  }
`

export const AuditLogSelect = styled(Select)<{ isselected?: string; noborder?: string }>`
  min-width: 113px;
  background: transparent;
  gap: ${theme.spacing.xSmall}px;
  border-radius: ${theme.attributes.borderRadius.large};
  border: 1px solid ${theme.colors.controlBorder};

  ${({ noborder }) =>
    noborder &&
    noborder === 'true' &&
    `
    border-radius: 0;
    border: 0;
    border-color: transparent;
    background: transparent;
  `};

  color: ${theme.colors.foreground};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  text-align: left;

  > * {
    border: none !important;
    outline: none !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  height: 40px;

  .MuiOutlinedInput-root {
    height: 40px;
  }

  svg {
    top: calc(50% - 0.8em);
    right: ${theme.spacing.xSmall}px;
    width: 24px;
    height: 24px;

    &.MuiSelect-icon {
      pointer-events: none;
      color: ${theme.colors.foreground};
      position: absolute;
    }

    &.MuiSelect-iconClosed {
      transform: rotate(0deg) !important;
    }

    &.MuiSelect-iconOpen {
      transform: rotate(180deg) !important;
    }

    path {
      fill: ${theme.colors.foreground};
    }
  }
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      marginTop: `${theme.spacing.half}px`,
      background: theme.colors.tooltipBg,
      boxShadow: theme.attributes.boxShadow.chipCircle,
      borderRadius: theme.attributes.borderRadius.secondary,
      minWidth: '250px !important',
      maxHeight: '486px !important',

      '.MuiList-root': {
        padding: `${theme.spacing.xSmall}px`,
        background: theme.colors.frameworkCardBg,
        borderRadius: theme.attributes.borderRadius.small
      },

      '.MuiMenuItem-root': {
        borderRadius: theme.attributes.borderRadius.small,
        height: '40px',
        gap: `${theme.spacing.half}px`,

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '&:hover': {
          background: theme.colors.tooltipBg
        },

        '.MuiCheckbox-root': {
          padding: `${theme.spacing.xSmall}px`,

          '&:hover': {
            background: 'rgba(202, 196, 208, 0.12)'
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.bold,
          fontSize: theme.typography.fontSize.xLarge,
          lineHeight: '24px',
          letterSpacing: '0.1px',
          color: `${theme.colors.foreground} !important`
        },

        '&.Mui-selected': {
          pointerEvents: 'none',

          '.MuiListItemText-root .MuiTypography-root': {
            overflow: 'hidden',
            color: `${theme.colors.caption} !important`,
            textOverflow: 'ellipsis',
            fontSize: theme.typography.fontSize.xLarge,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.normal,
            lineHeight: 'normal'
          }
        },

        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '.image-wrapper': {
          display: 'flex',

          '> img': {
            width: '18px',
            height: '18px',
            boxShadow: theme.attributes.boxShadow.chipCircle,
            margin: '-4.5px',
            borderRadius: theme.attributes.borderRadius.circle,

            '&:nth-of-type(1)': {
              zIndex: 10
            },
            '&:nth-of-type(2)': {
              zIndex: 9
            },
            '&:nth-of-type(3)': {
              zIndex: 8
            },
            '&:nth-of-type(4)': {
              zIndex: 7
            },
            '&:nth-of-type(5)': {
              zIndex: 6
            },
            '&:nth-of-type(6)': {
              zIndex: 5
            },
            '&:nth-of-type(7)': {
              zIndex: 4
            }
          }
        },

        '.textWrapper': {
          marginLeft: '13px'
        },

        '&.Mui-disabled': {
          opacity: 1,

          '.MuiCheckbox-root': {
            opacity: 0.38
          },

          svg: {}
        }
      },

      '&::-webkit-scrollbar-track': {
        background: '#3e2e3d'
      },

      '&::-webkit-scrollbar-thumb': {
        background: '#FBD8F5',
        height: '4px',
        width: '4px',
        border: '3px solid transparent',
        backgroundClip: 'content-box'
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
